import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
export function TopBar() {
  return <div className="bg-slate-950 text-slate-400 text-xs md:text-sm py-2 border-b border-slate-800" data-id="element-305">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-2" data-id="element-306">
        <div className="flex items-center gap-6" data-id="element-307">
          <a href="mailto:info@hardyblend.com" className="flex items-center gap-2 hover:text-red-500 transition-colors" data-id="element-308">
            <Mail className="w-4 h-4" data-id="element-309" />
            <span data-id="element-310">info@hardyblend.com</span>
          </a>
          <a href="tel:+447921876472" className="flex items-center gap-2 hover:text-red-500 transition-colors" data-id="element-311">
            <Phone className="w-4 h-4" data-id="element-312" />
            <span data-id="element-313">+44 7921 876472</span>
          </a>
        </div>
        <div className="flex items-center gap-2 hidden md:flex" data-id="element-314">
          <MapPin className="w-4 h-4" data-id="element-315" />
          <span data-id="element-316">London, United Kingdom</span>
        </div>
      </div>
    </div>;
}